// In your store file (e.g., store.ts)
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./ReduxUser.tsx";
import accessRightsReducer from "./ReduxAccessRight.tsx";
import accessModulesReducer from "./ReduxAccessModules.tsx";
import moduleParamJsonReducer from "./ReduxModuleParam.tsx";

// Define persist configurations
const userPersistConfig = {
  key: "user",
  storage,
};

const accessRightsPersistConfig = {
  key: "accessRights",
  storage,
};

const accessModulesPersistConfig = {
  key: "accessModules",
  storage,
};

const moduleParamJsonPersistConfig = {
  key: "moduleParamJson",
  storage,
};

// Create persisted reducers
const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedAccessRightsReducer = persistReducer(
  accessRightsPersistConfig,
  accessRightsReducer
);
const persistedAccessModulesReducer = persistReducer(
  accessModulesPersistConfig,
  accessModulesReducer
);
const persistedModuleParamJsonsReducer = persistReducer(
  moduleParamJsonPersistConfig,
  moduleParamJsonReducer
);

// Configure the Redux store
export const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    accessRights: persistedAccessRightsReducer,
    accessModules: persistedAccessModulesReducer,
    moduleParamJson: persistedModuleParamJsonsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", "persist/PURGE", "persist/REGISTER"],
      },
    }),
});

// Create and export the persistor
export const persistor = persistStore(store);

// Export types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Default export the store
export default store;